import BaseEntity from "@Shared/Entities/AbstractEntities/BaseEntity";
import { networkConstraints } from "./constraints";
import { migrate } from "./migrate";
export default class Network extends BaseEntity {
    constructor(data = {}) {
        super(migrate(data), networkConstraints);
    }
    get baseUrl() {
        return `${super.baseUrl}/network/${this.id}`;
    }
    get data() {
        const parent = super.data;
        const { version } = this._data;
        const { name } = this;
        return {
            ...parent,
            version,
            name,
        };
    }
    get links() {
        return {
            self: `${this.baseUrl}`,
        };
    }
    get name() {
        return this._data.name;
    }
}
